import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-question-circle",
  "use": "icon-question-circle-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-question-circle\"><path d=\"M527 35q-128 0-237 64-106 62-168 168-64 109-64 236t64 236q62 106 168 168 109 64 236.5 64T763 907q106-62 168-168 64-109 64-236t-64-236Q869 161 763 99 654 35 526 35h1zm0 878q-112 0-207-56-93-54-147-147-56-96-56-207t56-207q54-92 147-147 95-56 206.5-56T733 149q93 55 147 147 56 96 56 207t-56 207q-54 93-147 147-95 56-206 56zm-2-246q-19 0-32 13t-13 31.5 13 31.5 31.5 13 31.5-13 13-31.5-13-31.5-31-13zm9-411q-50 0-90.5 20T375 334l-8 10 46 47 10-14q22-30 47.5-43t61-13 56.5 16 21 43q0 23-17 42-11 12-42 33-36 25-50 42-24 28-24 63 0 38 33 66l8 7 55-35-17-12q-7-5-11-12t-4-12q0-16 16-32 9-10 37-29l1-1q40-27 57-47 29-34 29-77 0-53-41-86.5T534 256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/question-circle.svg
// module id = 1132
// module chunks = 2